// Import react libs
import {
    BarChart as Chart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

// Import color
import colors from '../../utils/styles/colors';

function BarChart({
    xAxisKey = null,
    yAxisKey = null,
    data = [],
    yAxisHoverLabel = null,
}) {
    if (!data || !data.length > 0) return null;

    return (
        <div style={{ width: '100%', overflow: 'auto' }}>
            <div style={{ minWidth: `${data.length * 50}px`, height: '450px' }}>
                <ResponsiveContainer width="100%" height={450}>
                    <Chart data={data} margin={{ top: 10, right: 30 }}>
                        <XAxis
                            dataKey={xAxisKey}
                            angle={-30}
                            interval={0}
                            height={100}
                            dy={30}
                        />
                        <YAxis allowDecimals={false} />
                        <Tooltip
                            formatter={(value) => [`${value}`, yAxisHoverLabel]}
                        />
                        <Bar
                            dataKey={yAxisKey}
                            fill={colors.primaryBeige}
                            maxBarSize={10}
                        />
                    </Chart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default BarChart;
